export async function readApiJson(res) {
  const contentType = res.headers.get('content-type') || '';
  const text = await res.text();
  if (!text) return {};

  const trimmed = text.trim();
  if (trimmed.startsWith('<!DOCTYPE') || trimmed.startsWith('<html') || trimmed.startsWith('<')) {
    const hint = res.url ? ` URL: ${res.url}` : '';
    const localHint =
      typeof window !== 'undefined' &&
      (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
        ? ' En local: en otra terminal ejecutá npm run server (puerto 5000) y reiniciá npm start si cambiaste .env.'
        : ' En Vercel dejá REACT_APP_API_URL vacío. Entrá por https://contsuite.com.ar.';
    throw new Error(
      `El servidor devolvió HTML en lugar de JSON (HTTP ${res.status}${hint}).${localHint}`
    );
  }

  if (contentType.includes('application/json') || trimmed.startsWith('{') || trimmed.startsWith('[')) {
    try {
      return JSON.parse(text);
    } catch {
      throw new Error('La respuesta del servidor no es JSON válido.');
    }
  }

  if (res.status === 404) {
    throw new Error('El endpoint no está disponible. Reiniciá el backend o verificá la URL de la API.');
  }

  throw new Error('Respuesta inesperada del servidor.');
}
